import { SECTION_ITEM_TYPE } from "@constants";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  title: "",
  shortDescription: "",
  description: "",
  learn: "",
  requirement: "",
  levelIds: [],
  thumbnailUrl: "",
  previewVideoUrl: "",
  thumbnailImg: {},
  previewVideo: {},
  requireLogin: false,
  requireEnroll: false,
  price: 0,
  discountPrice: 0,
  categoryId: "",
  audioLanguageIds: [],
  closeCaptionIds: [],
  sections: [],
  courseType: "free",
};

const editingCourseSlice = createSlice({
  name: "editingCourse",
  initialState,
  reducers: {
    addSection(state, action) {
      const newSection = { ...action.payload };
      state.sections.push(newSection);
    },
    changeOrderUnits(state, action) {
      const { sectionId, newUnits } = action.payload;
      const sectionIndex = state.sections.findIndex((s) => s.id === sectionId);
      if (sectionIndex === -1) return state;
      const section = state.sections[sectionIndex];
      section.units = newUnits;
    },
    addLecture(state, action) {
      const { sectionId, newItem } = action.payload;
      const sectionIndex = state.sections.findIndex((s) => s.id === sectionId);
      if (sectionIndex === -1) return state;
      const section = state.sections[sectionIndex];
      const newLecture = { ...newItem, isNew: true };
      section.units.push(newLecture);
      // section.lectures.push(newLecture);
    },

    changeSectionTitle(state, action) {
      const { sectionId, newTitle } = action.payload;
      const sectionIndex = state.sections.findIndex((s) => s.id === sectionId);
      if (sectionIndex === -1) return state;
      const section = state.sections[sectionIndex];
      section.title = newTitle;
    },
    editLecture(state, action) {
      const { sectionId, newItem } = action.payload;
      const sectionIndex = state.sections.findIndex((s) => s.id === sectionId);
      if (sectionIndex === -1) return state;
      const section = state.sections[sectionIndex];

      const lectureIndex = section.units.findIndex((l) => l.id === newItem.id);
      if (lectureIndex === -1) return state;

      section.units[lectureIndex] = newItem;
      // const lectureIndex = section.lectures.findIndex(
      //   (l) => l.id === newItem.id
      // );
      // if (lectureIndex === -1) return state;

      // section.lectures[lectureIndex] = newItem;
    },
    deleteLecture(state, action) {
      const { sectionId, lectureId } = action.payload;
      const sectionIndex = state.sections.findIndex((s) => s.id === sectionId);
      if (sectionIndex === -1) return state;
      const section = state.sections[sectionIndex];
      const lectureIndex = section.units.findIndex((l) => l.id === lectureId);
      if (lectureIndex === -1) return state;

      section.units[lectureIndex].isDeleted = true;

      // const lectureIndex = section.lectures.findIndex(
      //   (l) => l.id === lectureId
      // );
      // if (lectureIndex === -1) return state;

      // section.lectures[lectureIndex].isDeleted = true;
    },
    changeBasicInfo(state, action) {
      const basic = action.payload;
      return { ...state, ...basic };
    },
    changeMediaInfo(state, action) {
      const { thumbnailUrl, previewVideoUrl } = action.payload;
      const media = {
        thumbnailUrl,
        previewVideoUrl,
      };
      return { ...state, ...media };
    },
    changePriceInfo(state, action) {
      const price = action.payload;
      return { ...state, ...price };
    },
    updateSections(state, action) {
      const newSection = action.payload;
      state.sections = newSection;
    },
    deleteSection(state, action) {
      const { sectionId } = action.payload;
      const sectionIndex = state.sections.findIndex((s) => s.id === sectionId);
      if (sectionIndex === -1) return state;
      state.sections[sectionIndex].isDeleted = true;
    },
    updateCourse(state, action) {
      const newCourse = action.payload;
      return newCourse;
    },
    // changeCourseType(state, action) {
    //   state.courseType = action.payload;
    // },
    resetEditingCourse() {
      return initialState;
    },

    addQuiz(state, action) {
      const { sectionId, quiz } = action.payload;
      const sectionIndex = state.sections.findIndex(
        (section) => section.id === sectionId
      );
      if (sectionIndex === -1) return state;
      const section = state.sections[sectionIndex];
      const newQuiz = { ...quiz, isNew: true };
      section.units.push(newQuiz);
      // section.quizzes.push(newQuiz);
    },

    deleteQuiz(state, action) {
      const { sectionId, quizId } = action.payload;
      const sectionIndex = state.sections.findIndex(
        (section) => section.id === sectionId
      );
      if (sectionIndex === -1) return state;
      const section = state.sections[sectionIndex];
      const quizIndex = section.units.findIndex((quiz) => quiz.id === quizId);
      if (quizIndex === -1) return state;

      section.units[quizIndex].isDeleted = true;
    },

    editQuiz(state, action) {
      const { sectionId, newQuiz } = action.payload;
      const sectionIndex = state.sections.findIndex(
        (section) => section.id === sectionId
      );
      if (sectionIndex === -1) return state;
      const section = state.sections[sectionIndex];

      const quizIndex = section.units.findIndex(
        (quiz) => quiz.id === newQuiz.id
      );
      if (quizIndex === -1) return state;

      section.units[quizIndex] = newQuiz;

      //  const quizIndex = section.quizzes.findIndex(
      //    (quiz) => quiz.id === newQuiz.id
      //  );
      //  if (quizIndex === -1) return state;

      //  section.quizzes[quizIndex] = newQuiz;
    },

    addAssignment(state, action) {
      const { sectionId, assignment } = action.payload;
      const sectionIndex = state.sections.findIndex(
        (section) => section.id === sectionId
      );
      if (sectionIndex === -1) return state;
      const section = state.sections[sectionIndex];
      const newAssignment = { ...assignment, isNew: true };
      section.units.push(newAssignment);
      // section.quizzes.push(newQuiz);
    },
    deleteAssignment(state, action) {
      const { sectionId, assignmentId } = action.payload;
      const sectionIndex = state.sections.findIndex(
        (section) => section.id === sectionId
      );
      if (sectionIndex === -1) return state;
      const section = state.sections[sectionIndex];
      const assignmentIndex = section.units.findIndex(
        (unit) => unit.id === assignmentId
      );
      if (assignmentIndex === -1) return state;

      section.units[assignmentIndex].isDeleted = true;
    },

    editAssignment(state, action) {
      const { sectionId, newAssignment } = action.payload;
      const sectionIndex = state.sections.findIndex(
        (section) => section.id === sectionId
      );
      if (sectionIndex === -1) return state;
      const section = state.sections[sectionIndex];

      const assignmentIndex = section.units.findIndex(
        (unit) => unit.id === newAssignment.id
      );
      if (assignmentIndex === -1) return state;
      section.units[assignmentIndex] = newAssignment;
    },

    splitUnits(state) {
      const newSections = [...state.sections].map((section) => {
        const newSection = { ...section };
        const units = newSection.units.map((unit, index) => {
          return { ...unit, index };
        });

        const lectures = units.filter(
          (unit) => unit.type == SECTION_ITEM_TYPE.LECTURE
        );
        const quizzes = units.filter(
          (unit) => unit.type == SECTION_ITEM_TYPE.QUIZ
        );
        const assignments = units.filter(
          (unit) => unit.type == SECTION_ITEM_TYPE.ASSIGNMENT
        );

        return {
          ...newSection,
          lectures,
          quizzes,
          assignments,
        };
      });
      return { ...state, sections: newSections };
    },

    setCourseId(state, action) {
      state.id = action.payload;
    },
    publishCourse(state) {
      state.isActive = true;
    },
    setOldSection(state) {
      const newSections = state.sections.map((section) => {
        const newUnits = section.units?.map((unit) => {
          return { ...unit, isNew: false };
        });
        return { ...section, units: newUnits, isNew: false };
      });
      return { ...state, sections: newSections };
    },
  },
});

const { actions, reducer } = editingCourseSlice;

const editingCourseActions = actions;
const editingCourseReducer = reducer;

export { editingCourseActions, editingCourseReducer };
